import {
  CardContent,
  CardHeader,
  Divider,
  Tooltip as MuiTooltip,
  type TooltipProps,
  Typography,
  styled,
  tooltipClasses,
} from "@mui/material";
import type React from "react";

const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: 0,
  },
}));

interface Props {
  title: string;
  content: React.ReactNode;
  children: React.ReactElement;
}

const CardTooltip = (props: Props) => {
  return (
    <Tooltip
      placement="bottom-start"
      leaveDelay={200}
      slotProps={{
        popper: {
          onClick: (e) => e.stopPropagation(),
        },
      }}
      title={
        <>
          <CardHeader title={<Typography variant="h6">{props.title}</Typography>} />
          <Divider />
          <CardContent>{props.content}</CardContent>
        </>
      }
      sx={{ background: "transparent" }}
    >
      {props.children}
    </Tooltip>
  );
};

export { CardTooltip };
